import { createContext } from 'react';

const initialContext: ILocaleContext = {
  formatMessage: () => '',
  locale: 'en',
  setLocaleFromPaymentRequest: (_: string | null) => _,
  setLocaleSelectedByUser: (_: string) => _,
};

const LocaleContext = createContext(initialContext);
export default LocaleContext;
